import React, { useState, ChangeEvent, FormEvent } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import NavbarComponent from "./NavbarComponent";
import LoginComponent from "./LoginComponent";
import FooterComponent from "./FooterComponent";

interface ChangeLangState {
    generate: string;
    result: string;
    langChange: string;
}

const GuestChangelangComponent: React.FC = () => {
    const [state, setState] = useState<ChangeLangState>({
        generate: "",
        result: "",
        langChange: "0",
    });
    const { generate, result, langChange } = state;

    const inputValue = (name: keyof ChangeLangState) => (event: ChangeEvent<HTMLTextAreaElement>) => {
        setState({ ...state, [name]: event.target.value });
    };

    const handleChange = (event: ChangeEvent<HTMLSelectElement>) => {
        setState({ ...state, langChange: event.target.value });
    };

    const sendPostChangeLangForm = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        axios
            .post(`${process.env.REACT_APP_API}guest/returntext`, { text: generate, type: langChange },
                {
                    headers: {
                        Authorization: `Bearer `
                    }
                })
            .then(response => {
                console.log(response.data);
                setState({ ...state, result: response.data.return });
            }).catch(() => {
                Swal.fire(
                    "Error",
                    "ERROR",
                    "error",
                );
            });
    };

    return (
        <div className="d-flex h-100 bg-dark">
            <div className="cover-container d-flex w-100 h-100 p-3 mx-auto flex-column text-center text-white min-h-max">
                <NavbarComponent />
                <div className="container p-5">
                    <main className="px-3">
                        <form onSubmit={sendPostChangeLangForm}>
                            <div className="row">  
                                <label htmlFor="maintxt" className="col-3 col-form-label">Error EN : </label>
                                <div className="col-6">
                                    <textarea className="form-control" name="maintxt" id="maintxt" onChange={inputValue("generate")} value={generate}></textarea>
                                </div>
                                <div className="col-3">
                                    <input type="submit" className="btn btn-info" id="generate" value="Use the megic" />
                                </div>
                            </div>
                            <div className="row mt-5">  
                                <label htmlFor="result" className="col-3 col-form-label">Result : </label>
                                <div className="col-6">
                                    <textarea readOnly className="form-control" name="result" id="result" value={result}></textarea>
                                </div>
                                <div className="col-3">
                                    <select className="form-select" id="type_change" value={langChange} onChange={handleChange}>
                                        <option value="0">Swap All</option>
                                        <option value="1">Only EN to TH </option>
                                        <option value="2">Only TH to EN</option>
                                    </select>
                                </div>
                            </div>
                        </form>
                    </main>
                </div>
                <FooterComponent />
            </div>
            <LoginComponent />
        </div>
    );
};

export default GuestChangelangComponent;
